import { OnInit } from '@angular/core';
import { MatDatepicker, MatDialog } from '@angular/material';
import { FormBuilder } from '@angular/forms';
import { EsShopsService } from 'src/app/restapi/be-esquery';
import { take } from 'rxjs/operators';
import { dateFormat_Month, MONTH_FORMATS } from 'src/app/share/utils/common-utils';
import * as _moment from 'moment';
import { AlertDialogComponent, ConfirmDialogComponent } from 'fecommon';
var moment = _moment;
var ɵ0 = MONTH_FORMATS;
var RawDataShopGivingsComponent = /** @class */ (function () {
    function RawDataShopGivingsComponent(fb, esShopsService, dialog) {
        this.fb = fb;
        this.esShopsService = esShopsService;
        this.dialog = dialog;
    }
    RawDataShopGivingsComponent.prototype.ngOnInit = function () {
        this.initForm();
    };
    RawDataShopGivingsComponent.prototype.initForm = function () {
        this.form = this.fb.group({
            date: moment().add(-1, 'month'),
            dept_info: null
        });
    };
    Object.defineProperty(RawDataShopGivingsComponent.prototype, "fc_date", {
        get: function () { return this.form.get('date'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RawDataShopGivingsComponent.prototype, "fc_deptInfo", {
        get: function () { return this.form.get('dept_info'); },
        enumerable: true,
        configurable: true
    });
    RawDataShopGivingsComponent.prototype.chosenMonthHandler = function (normalizedMonth, datepicker) {
        this.fc_date.setValue(normalizedMonth);
        datepicker.close();
    };
    RawDataShopGivingsComponent.prototype.selectDept = function (value) {
        if (!value || value == null) {
            this.fc_deptInfo.setValue(null);
        }
        else {
            this.fc_deptInfo.setValue(value);
        }
    };
    RawDataShopGivingsComponent.prototype.download = function () {
        var _this = this;
        this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: '매장별 점기부 데이터',
                description: '다운로드 하시겠습니까?',
                okText: '확인',
                cancelText: '취소'
            }
        }).afterClosed().pipe(take(1)).subscribe(function (confirmed) {
            if (confirmed) {
                _this.shopgivingsExcelGet();
            }
        });
    };
    RawDataShopGivingsComponent.prototype.shopgivingsExcelGet = function () {
        var _this = this;
        this.esShopsService.shopsGivingsProductionExcelGet(dateFormat_Month(this.fc_date.value), dateFormat_Month(this.fc_date.value), this.fc_deptInfo.value != null ? this.fc_deptInfo.value.dept_id : null).pipe(take(1)).subscribe(function (res) {
            _this.dialog.open(AlertDialogComponent, {
                data: {
                    message: '이메일로 전송될 예정입니다.'
                }
            });
        }, function (err) { console.error(err); });
    };
    return RawDataShopGivingsComponent;
}());
export { RawDataShopGivingsComponent };
export { ɵ0 };
